module.exports = __webpack_public_path__ + "static/media/tz_36.d9a16889.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tz_36.png
// module id = 191
// module chunks = 1